import { render } from "./PrintablePanel.vue?vue&type=template&id=00b3884e&scoped=true&lang=pug"
import script from "./PrintablePanel.vue?vue&type=script&lang=js"
export * from "./PrintablePanel.vue?vue&type=script&lang=js"

import "./PrintablePanel.vue?vue&type=style&index=0&id=00b3884e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b3884e"]])

export default __exports__